import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column justify-content-center table-responsive" }
const _hoisted_2 = { class: "table" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "w-25" }
const _hoisted_6 = { class: "w-25" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WdwDynbox = _resolveComponent("WdwDynbox")!

  return (_ctx.askus.has_recommendations && _ctx.suggestions.length && _ctx.text != '')
    ? (_openBlock(), _createBlock(_component_WdwDynbox, {
        key: 0,
        title: "Diese Fragen könnten Ihrer ähnlich sein:",
        minimize: false,
        config: { showControls: true }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("table", _hoisted_2, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", null, _toDisplayString(_ctx.domainStore.translate('askus.question.title')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.domainStore.translate('askus.question.date')), 1),
                  _createElementVNode("th", null, _toDisplayString(_ctx.domainStore.translate('askus.question.status')), 1)
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.suggestions, (suggestion) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    class: "question-row",
                    key: suggestion.id,
                    onClick: ($event: any) => (_ctx.openQuestion(suggestion, suggestion.id))
                  }, [
                    _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.truncateAfterWord(suggestion.title, 50)), 1),
                    _createElementVNode("td", _hoisted_5, _toDisplayString(_ctx.formattedDate(suggestion.created, true)), 1),
                    _createElementVNode("td", _hoisted_6, _toDisplayString(suggestion.status), 1)
                  ], 8, _hoisted_3))
                }), 128))
              ])
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}